import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import { Routes } from '@generouted/react-router/lazy';
import Providers from './lib/providers';
import { AuthProvider } from './contexts/auth.context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from './contexts/theme.context';
import { ChatFileProvider } from './contexts/chat-file.context ';
import { ErrorBoundary } from './components/ErrorBoundary';

const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <ChatFileProvider>
            <QueryClientProvider client={queryClient}>
              <Providers>
                {/* <StrictMode> */}
                <Routes />
                {/* </StrictMode> */}
              </Providers>
            </QueryClientProvider>
          </ChatFileProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </HelmetProvider>,
);
